<template>
	<div class="logo h-auto">
		<img 
			class="w-full" 
			:style="{
				'maxWidth': maxWidth
			}"
			:src="src" 
		/>
	</div>
</template>

<script>
export default {
	name: 'UiLogo',
	props: {
		src: {
			type: String,
			required: true
		},
		maxWidth: {
			type: String,
			default: 'auto'
		}
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_fontface.css"></style>
<style src="@/assets/css/_variables.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/_animations.css"></style>
<style src="@/assets/css/main.css"></style>